var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.8369C18.4559 14.5683 19.7041 15.742 20.6152 17.2096C20.7956 17.5003 20.8858 17.6456 20.917 17.8468C20.9804 18.2558 20.7008 18.7585 20.3199 18.9204C20.1325 19 19.9216 19 19.5 19M15 9.53224C16.4817 8.79589 17.5 7.26686 17.5 5.5C17.5 3.73314 16.4817 2.20411 15 1.46776M13 5.5C13 7.98528 10.9852 10 8.49996 10C6.01468 10 3.99996 7.98528 3.99996 5.5C3.99996 3.01472 6.01468 1 8.49996 1C10.9852 1 13 3.01472 13 5.5ZM1.55919 16.9383C3.1535 14.5446 5.66933 13 8.49996 13C11.3306 13 13.8464 14.5446 15.4407 16.9383C15.79 17.4628 15.9646 17.725 15.9445 18.0599C15.9289 18.3207 15.7579 18.64 15.5495 18.7976C15.2819 19 14.9138 19 14.1776 19H2.82232C2.08613 19 1.71804 19 1.4504 18.7976C1.24201 18.64 1.07105 18.3207 1.05539 18.0599C1.03529 17.725 1.20992 17.4628 1.55919 16.9383Z",
    stroke: "#F0F5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.c91d3e542fec8b02fbdace6d47f26378.svg";
export { ForwardRef as ReactComponent };